module.exports = __webpack_public_path__ + "assets/95c52f4a78b1bf93154f93f296af99a6.png";